<template>
    <div>
        <v-container fluid v-if="value">
            <v-tooltip right>
                <v-btn
                        slot="activator"
                        fixed
                        dark
                        fab
                        bottom
                        color="pink"
                        @click.stop="$emit('back')"
                >
                    <v-icon>ti ti-arrow-left</v-icon>
                </v-btn>
                <span>Volver a prescripciones</span>
            </v-tooltip>
            <v-toolbar class="elevation-1" dense>
                <v-list-tile class="v-list-tile-pl0 v-list-prescripcion-toolbar">
                    <v-list-tile-avatar>
                        <v-icon class="white--text" :class="$route.meta.pageTitle.avatar.color">{{$route.meta.pageTitle.avatar.icon}}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                        <v-list-tile-title class="title">Detalle prescripción</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-toolbar>
        </v-container>
        <v-container fluid pt-0 v-if="value">
            <v-layout row wrap border-rad-sm overflow-hidden>
                <v-flex v-for="(prop, index) in props.filter(x => x.visible)" :class="prop.flexClass">
                    <v-list two-line class="notification-wrap" :key="index">
                        <template>
                            <v-hover>
                                <v-list-tile
                                        avatar
                                        ripple
                                        slot-scope="{hover}"
                                        :class="hover ? darkMode ? 'blue-grey darken-3' : 'grey lighten-4' : '' "
                                >
                                    <v-list-tile-avatar>
                                        <v-icon :color="prop.iconColor">{{prop.icon}}</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-sub-title class="grey--text fs-12 fw-normal">{{prop.label}}</v-list-tile-sub-title>
                                        <v-list-tile-title style="height: 18px !important;"><h6 class="mb-0">{{prop.body}}</h6></v-list-tile-title>
                                        <v-list-tile-sub-title class="grey--text fs-12 fw-normal">{{prop.sublabel}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action v-if="prop.action">
                                        <v-list-tile-action-text>{{prop.action}}</v-list-tile-action-text>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-hover>
                        </template>
                    </v-list>
                </v-flex>
            </v-layout>
            <v-layout class="mt-3" row wrap border-rad-sm overflow-hidden v-if="seeTabs">
                <v-flex xs12>
                    <v-tabs grow>
                        <v-tab v-if="seeMedicamentos" class="font-weight-bold">Medicamentos</v-tab>
                        <v-tab v-if="seeComplementarios" class="font-weight-bold">Servicios Complementarios</v-tab>
                        <v-tab v-if="seeNutricionales" class="font-weight-bold">Productos Nutricionales</v-tab>
                        <v-tab v-if="seeProcedimientos" class="font-weight-bold">Procedimientos</v-tab>
                        <v-tab v-if="seeDispositivos" class="font-weight-bold">Dispositivos Médicos</v-tab>
                        <v-tab-item v-if="seeMedicamentos">
                            <tecnologias v-model="value" key-tecnologia="medicamentos"></tecnologias>
                        </v-tab-item>
                        <v-tab-item v-if="seeComplementarios">
                            <tecnologias v-model="value" key-tecnologia="complementarios"></tecnologias>
                        </v-tab-item>
                        <v-tab-item v-if="seeNutricionales">
                            <tecnologias v-model="value" key-tecnologia="nutricionales"></tecnologias>
                        </v-tab-item>
                        <v-tab-item v-if="seeProcedimientos">
                            <tecnologias v-model="value" key-tecnologia="procedimientos"></tecnologias>
                        </v-tab-item>
                        <v-tab-item v-if="seeDispositivos">
                            <tecnologias v-model="value" key-tecnologia="dispositivos"></tecnologias>
                        </v-tab-item>
                    </v-tabs>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'DetailPrescripcion',
        props: {
            value: {
                type: Object,
                default: null
            }
        },
        components: {
            Tecnologias: () => import('@/components/Prescripciones/ServiciosTecnologias/Tecnologias')
        },
        data: () => ({
            props: []
        }),
        computed: {
            ...mapGetters([
                'darkMode'
            ]),
            seeMedicamentos () {
                return this.value.medicamentos.length
            },
            seeNutricionales () {
                return this.value.nutricionales.length
            },
            seeProcedimientos () {
                return !!this.value.procedimientos.length
            },
            seeComplementarios () {
                return this.value.complementarios.length
            },
            seeDispositivos () {
                return this.value.dispositivos.length
            },
            seeTabs () {
                return this.seeMedicamentos || this.seeNutricionales || this.seeProcedimientos || this.seeComplementarios || this.seeDispositivos
            }
        },
        watch: {
            'value' (val) {
                val && this.reloadData()
            }
        },
        methods: {
            reloadData () {
                this.props = [
                    {
                        body: this.value.NoPrescripcion,
                        label: 'Número',
                        action: '',
                        sublabel: '',
                        icon: 'label',
                        iconColor: 'primary',
                        flexClass: 'xs12 sm6 md4 lg3',
                        visible: true
                    },
                    {
                        body: `${this.moment(this.value.FPrescripcion).format('YYYY-MM-DD')} ${this.value.HPrescripcion ? this.moment(this.value.HPrescripcion, 'HH:mm:ss').format('HH:MM') : ''}`,
                        label: 'Fecha',
                        action: '',
                        sublabel: '',
                        icon: 'event',
                        iconColor: 'warning',
                        flexClass: 'xs12 sm6 md4 lg3',
                        visible: true
                    },
                    {
                        body: this.value.EstadoPrescripcion,
                        label: 'Estado',
                        action: '',
                        sublabel: '',
                        icon: 'bookmark',
                        iconColor: 'info',
                        flexClass: 'xs12 sm6 md4 lg3',
                        visible: true
                    },
                    {
                        body: this.value.AmbitoAtencion,
                        label: 'Ambito de atención',
                        action: '',
                        sublabel: (this.value.RefAmbAte && this.value.RefAmbAte === 1) ? 'Con Referencia y ContraReferencia' : '',
                        icon: 'mdi mdi-hotel',
                        iconColor: 'success',
                        flexClass: 'xs12 sm6 md6 lg3',
                        visible: true
                    },
                    {
                        body: `Código: ${this.value.CodEPS}`,
                        label: 'EPS',
                        action: '',
                        sublabel: ``,
                        icon: 'fas fa-hospital-alt',
                        iconColor: 'indigo',
                        flexClass: 'xs12 sm12 md6 lg6',
                        visible: true
                    },
                    {
                        body: (this.value.TipoIDMadrePaciente && this.value.NroIDMadrePaciente ? `${this.value.TipoIDPaciente}${this.value.NroIDPaciente} - ` : '') + [this.value.PNPaciente, this.value.SNPaciente, this.value.PAPaciente, this.value.SAPaciente].join(' '),
                        label: 'Paciente',
                        action: '',
                        sublabel: this.value.TipoIDMadrePaciente && this.value.NroIDMadrePaciente ? `Identificación Madre: ${this.value.TipoIDMadrePaciente}${this.value.NroIDMadrePaciente}` : `${this.value.TipoIDPaciente}${this.value.NroIDPaciente}`,
                        icon: 'fas fa-user',
                        iconColor: 'purple',
                        flexClass: 'xs12 sm12 md12 lg6',
                        visible: true
                    },
                    {
                        body: `${this.value.TipoIDIPS}${this.value.NroIDIPS} - Cód: ${this.value.CodHabIPS}`,
                        label: 'IPS',
                        action: '',
                        sublabel: `${this.value.municipio_ips.nombre}, ${this.value.DirSedeIPS} - Tel: ${this.value.TelSedeIPS}`,
                        icon: 'fas fa-clinic-medical',
                        iconColor: 'error',
                        flexClass: 'xs12 sm12 md6 lg6',
                        visible: true
                    },
                    {
                        body: [this.value.PNProfS, this.value.SNProfS, this.value.PAProfS, this.value.SAProfS].join(' '),
                        label: 'Profesional',
                        action: '',
                        sublabel: `${this.value.TipoIDProf}${this.value.NumIDProf} - Reg: ${this.value.RegProfS}`,
                        icon: 'fas fa-user-md',
                        iconColor: 'teal',
                        flexClass: 'xs12 sm12 md6 lg6',
                        visible: true
                    },
                    {
                        body: this.value.dx_principal ? this.value.dx_principal.descripcion : '',
                        label: 'Diagnóstico principal',
                        action: '',
                        sublabel: `Código: ${this.value.dx_principal ? this.value.dx_principal.codigo : ''}`,
                        icon: 'fas fa-notes-medical',
                        iconColor: 'amber',
                        flexClass: 'xs12',
                        visible: true
                    },
                    {
                        body: this.value.dx1 ? this.value.dx1.descripcion : '',
                        label: 'Diagnóstico relacionado 1',
                        action: '',
                        sublabel: `Código: ${this.value.dx1 ? this.value.dx1.codigo : ''}`,
                        icon: 'fas fa-notes-medical',
                        iconColor: 'yellow',
                        flexClass: 'xs12',
                        visible: !!this.value.dx1
                    },
                    {
                        body: this.value.dx2 ? this.value.dx2.descripcion : '',
                        label: 'Diagnóstico relacionado 2',
                        action: '',
                        sublabel: `Código: ${this.value.dx2 ? this.value.dx2.codigo : ''}`,
                        icon: 'fas fa-notes-medical',
                        iconColor: 'yellow',
                        flexClass: 'xs12',
                        visible: !!this.value.dx2
                    }
                ]
            }
        }
    }
</script>

<style>
.v-list-prescripcion-toolbar>div {
    height: 52px !important;
}
</style>
